var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2719_90345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8571 24H16.5714C15.941 24 15.4286 23.4839 15.4286 22.8488V15.654C15.4286 15.019 14.9162 14.5028 14.2857 14.5028H9.71429C9.08381 14.5028 8.57143 15.019 8.57143 15.654V22.8488C8.57143 23.4839 8.05905 24 7.42857 24H1.14286C0.512381 24 0 23.4839 0 22.8488V7.40012C0 6.98762 0.219048 6.60581 0.575238 6.40052L11.4324 0.151579C11.7829 -0.0498755 12.2152 -0.0498755 12.5657 0.151579L23.4229 6.40052C23.779 6.60581 23.9981 6.98762 23.9981 7.40012V22.8488C23.9981 23.4839 23.4857 24 22.8552 24H22.8571Z",
    fill: "#02486B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8571 24H16.5714C15.941 24 15.4286 23.4839 15.4286 22.8488V15.654C15.4286 15.019 14.9162 14.5028 14.2857 14.5028H9.71429C9.08381 14.5028 8.57143 15.019 8.57143 15.654V22.8488C8.57143 23.4839 8.05905 24 7.42857 24H1.14286C0.512381 24 0 23.4839 0 22.8488V7.40012C0 6.98762 0.219048 6.60581 0.575238 6.40052L11.4324 0.151579C11.7829 -0.0498755 12.2152 -0.0498755 12.5657 0.151579L23.4229 6.40052C23.779 6.60581 23.9981 6.98762 23.9981 7.40012V22.8488C23.9981 23.4839 23.4857 24 22.8552 24H22.8571Z",
    fill: "black",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2719_90345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/IconHome.24edd6f827063def2078182ec0103e95.svg";
export { ForwardRef as ReactComponent };